// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PeopleExpandSvg from '@rsuite/icon-font/lib/people/PeopleExpand';
var PeopleExpand = createSvgIcon({
  as: PeopleExpandSvg,
  ariaLabel: 'people expand',
  category: 'people',
  displayName: 'PeopleExpand'
});
export default PeopleExpand;